import { useTranslation } from 'react-i18next';

import { Box, TextField } from '@mui/material';
import { SCUIButton, SCUINoRecordComponent } from '../../../../atomic/atoms';
import { SCUICustomDataGrid } from '../../../../atomic/molecules';

import airdropShipment from '../../../../assets/icons/svg/pageIcons/airdropShipment.svg';
import TimeHelper from '../../../../utils/time';

import { SL } from '../summaryList.classes';

interface SummaryListTableProps {
    summaryList: any[];
    icmalDate: string;
    setIcmalDate: (date: string) => void;
    handleSearch: () => void;
    isSearched: boolean;
    onEdit: (row: any) => void;
}

export const SummaryListTable = ({
    summaryList,
    icmalDate,
    setIcmalDate,
    handleSearch,
    isSearched,
    onEdit,
}: SummaryListTableProps) => {
    const { t } = useTranslation();

    const formatPeriod = (row: any) => {
        const begin = row?.periodBeginDate ? TimeHelper.formatDateWithDot(row.periodBeginDate) : '';
        const end = row?.periodEndDate ? TimeHelper.formatDateWithDot(row.periodEndDate) : '';
        if (begin && end && begin !== end) {
            return `${begin} - ${end}`;
        }
        return begin || end || '-';
    };

    const columns = [
        {
            field: 'id',
            headerName: t('summaryAggregation.summaryList.columns.id'),
            flex: 1,
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'period',
            headerName: t('summaryAggregation.summaryList.columns.period'),
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (values: any) => formatPeriod(values?.row),
        },
        {
            field: 'createdDate',
            headerName: t('summaryAggregation.summaryList.columns.createdDate'),
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (values: any) => formatPeriod(values?.row),
        },
        {
            field: 'edit',
            headerName: t('summaryAggregation.summaryList.columns.edit'),
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (values: any) => (
                <SCUIButton
                    text={t('general.edit')}
                    type="primary"
                    className={SL.btnEdit}
                    sizeType="fixed"
                    buttonType="button"
                    size={'m'}
                    fullwidth
                    onClick={() => onEdit(values?.row)}
                />
            ),
        },
    ];

    return (
        <Box className={SL.list}>
            <Box
                className={SL.listSearchBar}
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    margin: '24px 0 32px 0',
                    gap: 2,
                    '& .sc-btn__text': {
                        padding: '8px 16px !important',
                    },
                }}
            >
                <p
                    className={SL.listSearchLabel}
                    style={{ fontSize: '14px', fontWeight: '600', margin: 0 }}
                >
                    {t('summaryAggregation.summaryList.icmalDate')}:
                </p>
                <TextField
                    className={SL.dateInput}
                    type="date"
                    size="small"
                    value={icmalDate}
                    onChange={(e) => setIcmalDate(e.target.value)}
                    sx={{ minWidth: 180 }}
                />
                <SCUIButton
                    className={SL.btnSearch}
                    text={t('general.search')}
                    type="primary"
                    sizeType="fixed"
                    size={'m'}
                    disabled={!icmalDate}
                    onClick={handleSearch}
                />
            </Box>
            <Box className={SL.listGridContainer}>
                {!isSearched ? (
                    <Box className={SL.listNoRecord}>
                        <SCUINoRecordComponent img={airdropShipment} />
                    </Box>
                ) : (
                    <Box className={SL.listGrid}>
                        <SCUICustomDataGrid
                            getRowClassName={'sa-summary-list-grid'}
                            rows={summaryList || []}
                            columns={columns}
                            rowHeight={75}
                        />
                    </Box>
                )}
            </Box>
        </Box>
    );
};
